module.exports = __webpack_public_path__ + "static/media/diagram_01.69333f61.svg";